var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Communication / message"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.33317 2.66602H12.6665C13.1969 2.66602 13.7056 2.87673 14.0807 3.2518C14.4558 3.62687 14.6665 4.13558 14.6665 4.66602V11.3327C14.6665 11.8631 14.4558 12.3718 14.0807 12.7469C13.7056 13.122 13.1969 13.3327 12.6665 13.3327H3.33317C2.80274 13.3327 2.29403 13.122 1.91895 12.7469C1.54388 12.3718 1.33317 11.8631 1.33317 11.3327V4.66602C1.33317 4.13558 1.54388 3.62687 1.91895 3.2518C2.29403 2.87673 2.80274 2.66602 3.33317 2.66602ZM3.6065 3.99935L7.5265 7.91935C7.58848 7.98183 7.66221 8.03143 7.74345 8.06528C7.82469 8.09912 7.91183 8.11655 7.99984 8.11655C8.08784 8.11655 8.17498 8.09912 8.25622 8.06528C8.33746 8.03143 8.41119 7.98183 8.47317 7.91935L12.3932 3.99935H3.6065ZM2.6665 11.3327C2.6665 11.5095 2.73674 11.6791 2.86176 11.8041C2.98679 11.9291 3.15636 11.9993 3.33317 11.9993H12.6665C12.8433 11.9993 13.0129 11.9291 13.1379 11.8041C13.2629 11.6791 13.3332 11.5095 13.3332 11.3327V4.93935L9.41317 8.85935C9.03817 9.23388 8.52984 9.44426 7.99984 9.44426C7.46983 9.44426 6.9615 9.23388 6.5865 8.85935L2.6665 4.93935V11.3327Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSmall);
export default __webpack_public_path__ + "static/media/email_small.eab5f216555ac7877eb7c012674a2fee.svg";
export { ForwardRef as ReactComponent };